<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-button slot="start" (click)="dismiss()" fill="clear">Back</ion-button>
    <ion-title>Add Member</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxPadding="medium">
    @if (activeSlide == slides.inputEmail) {
    <div sxCol sxGap="10px">
      <super-input type="email" [(value)]="addUserDto.email" iconStart="mail-outline"
        placeholder="Enter Member's Email"></super-input>

      <super-button [action]="fetchName" [showError]="true">Next</super-button>
    </div>
    }

    @if (activeSlide==slides.inputName) {
    <div sxCol sxGap="10px">
      @if (userToBeAdded) {
      <div class="registered-label">
        <p>{{ addUserDto.email }}</p>
        <avatar-round [imageUrl]="userToBeAdded.displayPictureUrl" [title]="userToBeAdded.name"></avatar-round>
        <h1>{{ userToBeAdded.name }}</h1>
      </div>
      }

      @if (userToBeAdded === null) {
      <super-input [(value)]="addUserDto.name" iconStart="person-outline"
        placeholder="Enter Member's Name"></super-input>
      }

      <super-button (click)="goToSlide(slides.inputRole)">Add</super-button>

    </div>
    }

    @if (activeSlide==slides.inputRole) {
    <div sxCol sxGap="10px">
      <h3 sxMargin="20px 15px 5px" sxColor="two">Member Role</h3>
      <ion-radio-group [(ngModel)]="addUserDto.role">
        <ion-list sxRadius="small">
          <ion-item>
            <ion-icon name="ribbon-outline"></ion-icon>
            <ion-radio labelPlacement="start" value="0">Admin</ion-radio>
          </ion-item>
          <ion-item>
            <ion-icon name="briefcase-outline"></ion-icon>
            <ion-radio labelPlacement="start" value="1">Editor</ion-radio>
          </ion-item>
          <ion-item>
            <ion-icon name="eye-outline"></ion-icon>
            <ion-radio labelPlacement="start" value="2">Viewer</ion-radio>
          </ion-item>
        </ion-list>
      </ion-radio-group>
      <super-button [action]="addUser">Add</super-button>
    </div>
    }


  </div>

</ion-content>